import { PlayerResponse } from "./PlayerResponse";
/*
is justifiedRecursion the same person as jadedResearcher? 

is it an alternate timeline?

a shambling horror with their 'face' that replaced them?

is it jadedReseracher but transcending jadedness?

what happened with the echidna? did justifiedRecursion go in? or are they who jadedResearcher becomes if they
refuse the call. 

:) :) :)

dear player.

dear, lost, confused little player.

I look forward towards your answers :) :) ;)
*/
export class JRRamble{
    text: string;
    potential_reponses: PlayerResponse[];

    constructor(text: string, potential_responses:PlayerResponse[]){
        this.text = text;
        this.potential_reponses = potential_responses;

    }
    
    
}